import { AutoMap } from "@automapper/classes";
import { EEntreeProcessType } from "./enums/entree-process-type";
import { EEntreeZoneType } from "./enums/entree-zone";
import { EEPIType } from "./enums/epi-type";

export class Securite {
    @AutoMap()
    EntreeZone!: EEntreeZoneType | EEntreeProcessType;
    @AutoMap()
    DureeExposition!: number;
    @AutoMap()
    Epi!: EEPIType;
    @AutoMap()
    MoyenObservation!: number;

    public constructor(init?: Partial<Securite>) {
        Object.assign(this, init);
    }
}